import { useMsal } from "@azure/msal-react";
import * as React from "react";

import { Role } from "../types";

export const useAuthorization = () => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const checkAccess = React.useCallback(
    ({ allowedRoles }: { allowedRoles: (Role | undefined)[] }) => {
      const userRoles = activeAccount?.idTokenClaims?.["roles"] ?? [];

      if (allowedRoles && allowedRoles.length > 0) {
        for (const role of allowedRoles) {
          if (role && userRoles.includes(role)) {
            return true;
          }
        }

        return false;
      }

      return true;
    },
    [activeAccount],
  );

  return { checkAccess };
};
